import { LinkButton } from '@cian/ui-kit';

import { type FC } from 'react';

import { Callback } from '../../../../../../containers/Callback';
import { PikPhoneNumber } from '../../../../../../containers/PikPhoneNumber';
import { ECallbackPlace } from '../../../../../../types/callback';
import { useApplicationContext } from '../../../../../../utils/applicationContext';
import { getCianMortgagePromoUrl } from '../../../../utils/getCianMortgagePromoUrl';

import styles from './ActionButtons.css';

export interface IActionButtonContainerProps {
  onMortgageClick: () => void;
  cianMortgage: boolean;
}

export const ActionButtons: FC<IActionButtonContainerProps> = props => {
  const { cianMortgage, onMortgageClick } = props;
  const { config } = useApplicationContext();

  if (cianMortgage) {
    return (
      <LinkButton
        fullWidth
        href={getCianMortgagePromoUrl(config)}
        size="M"
        theme="fill_secondary"
        onClick={onMortgageClick}
      >
        Получить ипотеку онлайн
      </LinkButton>
    );
  }

  return (
    <div className={styles['container']}>
      <PikPhoneNumber />
      <Callback place={ECallbackPlace.MortgageCalculator} size="small" />
    </div>
  );
};
